// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-box[data-v-04dec0f5]{width:calc(100% - 20px);height:80px;padding:10px;display:flex;justify-content:center;align-items:center}", ""]);
// Exports
module.exports = exports;
